import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';

import { Observable, of } from 'rxjs';

import { Globals } from '@core/globals';
import { GlobalsService } from '@services/globals.service';
import { SsrService } from '@services/ssr.service';
import { FinancingFormService } from '@services/financing-form.service';
import { FinancingFormAccessoriesResponse } from '@models/financing-form.model';

export const financingFormResolver: ResolveFn<Observable<{ accessoriesList: FinancingFormAccessoriesResponse | undefined }>> = (route) => {
  const carId = route.queryParamMap.get('car');
  const globalsService = inject(GlobalsService);
  const financingFormService = inject(FinancingFormService);
  const ssrService = inject(SsrService);
  const router = inject(Router);
  const globals = inject(Globals);
  const fragmentParams = globalsService.getFragmentParams(route.fragment);

  if (carId) {
    if (ssrService.isBrowser()) {
      const loanType = Number(fragmentParams['loan-type'] ?? 1);
      if (fragmentParams['months'] && fragmentParams['advance']) {
        let type: string = route.data['type'];
        if ((type === 'accessories' || type === 'contact-form') && financingFormService.product() === undefined) {
          router.navigate([globals.routes()['financingFormProducts'].url], { queryParams: { car: carId }, fragment: 'months=' + Number(fragmentParams['months']) + '&advance=' + Number(fragmentParams['advance']) + '&loan-type=' + loanType + '&saved-form=true' });
        }
      } else {
        router.navigate([globals.routes()['financingFormCalculator'].url], { queryParams: { car: carId }, fragment: 'months=' + Number(fragmentParams['months'] ?? 60) + '&advance=' + Number(fragmentParams['advance'] ?? 0) + '&loan-type=' + loanType + '&saved-form=true' });
      }
      return of({ accessoriesList: undefined });
    } else {
      return of({ accessoriesList: undefined });
    }
  } else {
    router.navigate([globals.routes()['homepage'].url]);
    return of({ accessoriesList: undefined });
  }
};
